<script>
import AboutMoreSwiper from '../../components/aboutMoreSwiper.vue';
import ContactForm from '../../components/contactForm.vue';

export default {
    name: "aboutMore",
    data() {
        return {
            detail: {
                model: [],
            },
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
    computed: {},
    components: {
        AboutMoreSwiper,
        ContactForm
    },
    mounted() {
        this.$store.dispatch('getAboutMore', {
            id: this.$route.query.id
        }).then((result) => {
            if (result.code == 100) { 
                this.detail = result.data;
            }
        }).catch((err) => {
            
        });
    },
    destroyed() {},
    watch: {},
    methods: {
        menuTap(index) { 
            let offsetTop = this.$refs.list[index].$el.offsetTop;
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth",
            });
        },
    },
};
</script>

<template>
    <div class="about_more">
        <!--  -->
        <div class="top">
            <div class="layout_bg bg" :style="`background-image: url(${detail.background_img1});`"></div>
            <div class="layout_main text_shadow content">
                <p class="title">{{ detail.name }}</p>
                <p class="desc" v-html="$textToHtml(detail.desc)"></p>
            </div>
        </div>
        <!--  -->
        <div class="list">
            <div class="layout_bg bg" :style="`background-image: url(${detail.background_img2});`"></div>
            <div class="layout_main content flex justify_center align_center only_pc">
                <div class="item" v-for="(item, index) in detail.model" :key="index" @click="menuTap(index)">
                    <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                    <p class="name text_shadow">{{ item.name }}</p>
                </div>
            </div>
            <swiper class="swiper only_mobile" ref="mySwiper" :options="swiperOptions" v-if="detail.model.length > 0">
                <swiper-slide v-for="(item, index) in detail.model" :key="index">
                    <div class="item" @click="menuTap(index)">
                        <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                        <p class="name text_shadow">{{ item.name }}</p>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!--  -->
        <AboutMoreSwiper ref="list" v-for="(item, index) in detail.model" :key="index" :data="item"/>
        <!--  -->
        <ContactForm from="关于我们"/>
    </div>
</template>

<style scoped lang="scss">
.list{
    height: 7.5rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
    }
    .content{
        height: 100%;
        gap: .65rem;
    }
    .item{
        cursor: pointer;
        .cover{
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            margin-bottom: .4rem;
        }
        .name{
            font-size: .3rem;
            text-align: center;
            color: #fff;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 10rem;
        .swiper{
            height: 100%;
            .swiper-pagination{
                display: flex;
                justify-content: center;
                gap: .1rem;
                bottom: .6rem;
                display: none;
                @media only screen and (max-width: 750px) {
                    display: flex;
                }
                /deep/ .swiper-pagination-bullet{
                    opacity: 1;
                    margin: 0;
                    width: .14rem;
                    height: .14rem;
                    background: none;
                    border: 1px solid #fff;
                    &-active{
                        background: #fff;
                    }
                }
            }
        }
        .item{
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .cover{
                width: 4.1rem;
                height: 4.1rem;
                margin-bottom: .7rem;
            }
            .name{
                font-size: .48rem;
            }
        }
    }
}
.top{
    height: 4.8rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
    }
    .content{
        height: 100%;
        flex-direction: column;
        text-align: center;
        font-size: .24rem;
        padding-top: 2rem;
        color: #fff;
        .title{
            font-size: .35rem;
            margin-bottom: .5rem;
        }
        .desc{
            padding: 0 .9rem;
        }
    }
    @media only screen and (max-width: 750px) {
        height: 10.64rem;
        .content{
            display: flex;
            padding-top: 0;
            padding-bottom: 1.2rem;
            justify-content: flex-end;
            .title{
                font-weight: bold;
                font-size: .42rem;
            }
            .desc{
                font-size: .28rem;
                padding: 0;
            }
        }
    }
}
</style>